/* Hobby-vs-commercial popup: the trigger opens a native <dialog> via
   showModal(), so Esc, focus trapping and focus restore are the browser's job.
   Closes on the X, on a backdrop click (detected as a click landing on the
   dialog element rather than the inner panel), and on Esc.

   Same shape as esc-info-faq.js — kept separate because this one also has to
   open itself when a merchant selects a row block in the theme editor, which
   the FAQ popup has no equivalent of. */
class EscComparePopup extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-compare-trigger]');
    this.dialog = this.querySelector('dialog');
    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', () => this.open());

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    const close = this.querySelector('[data-compare-close]');
    if (close) close.addEventListener('click', () => this.dialog.close());

    if (!this.dataset.designMode) return;

    // Theme editor: a merchant clicking a comparison row in the sidebar would
    // otherwise be editing something they cannot see.
    this.onSelect = (event) => {
      if (this.contains(event.target) || event.target === this) this.open();
    };
    this.onDeselect = (event) => {
      if (event.target === this && this.dialog.open) this.dialog.close();
    };
    document.addEventListener('shopify:block:select', this.onSelect);
    document.addEventListener('shopify:section:select', this.onSelect);
    document.addEventListener('shopify:section:deselect', this.onDeselect);
  }

  disconnectedCallback() {
    if (!this.onSelect) return;
    document.removeEventListener('shopify:block:select', this.onSelect);
    document.removeEventListener('shopify:section:select', this.onSelect);
    document.removeEventListener('shopify:section:deselect', this.onDeselect);
  }

  open() {
    if (this.dialog.open) return;
    // showModal is what gives us Esc and the backdrop; the attribute fallback
    // keeps the matrix reachable on anything that lacks it.
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }
}

if (!customElements.get('esc-compare-popup')) {
  customElements.define('esc-compare-popup', EscComparePopup);
}
